"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadServiceLineStatus = void 0;
var LeadServiceLineStatus;
(function (LeadServiceLineStatus) {
    LeadServiceLineStatus[LeadServiceLineStatus["Inventoried"] = 0] = "Inventoried";
    LeadServiceLineStatus[LeadServiceLineStatus["Scheduled"] = 1] = "Scheduled";
    LeadServiceLineStatus[LeadServiceLineStatus["In Progress"] = 2] = "In Progress";
    LeadServiceLineStatus[LeadServiceLineStatus["Completed"] = 3] = "Completed";
})(LeadServiceLineStatus = exports.LeadServiceLineStatus || (exports.LeadServiceLineStatus = {}));
//# sourceMappingURL=LeadServiceLineStatus.js.map